import { getBrandCode } from "core/utils/getBrandCode";
import { useTranslation } from "react-i18next";

export function useBrandName() {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Brand:BrandName" });
  const brandCode = getBrandCode();
  return t(brandCode ?? "default");
}
